import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {View} from 'react-native';

//////////////////////////
///////  utils
import {getRecentTopPhotos, getDailyChallenges} from 'src/Utils/apiCalls';
import {formatDailyChallenges} from 'src/Utils/dataFormatter';
import {setCommunityPhotos} from 'src/Redux/reducers/communityPhotos.reducer.js';

import {setDailyChallenges} from 'src/Redux/reducers/dailyChallenges.reducer.js';

//////////////////////////
///////  components
import {TopTab, TopTabButton} from 'src/Modules/TabViews';
import CommunityPhotos from 'src/LandingPage/CommunityPhotos';
import CommunityChallenges from 'src/LandingPage/CommunityChallenges';
import CallSupportLine from 'src/HeaderComponents/CallSupportLine';

import {useUserId} from 'src/Hooks/reduxHooks';

const CommunityPage = () => {
  const communityPhotos = useSelector((state) => state.communityPhotos);

  const userId = useUserId();
  const dispatch = useDispatch();

  console.log({communityPhotos});

  const [view, setView] = useState('daily');

  const fetchSetTopPhotos = async () => {
    const communityPhotos = await getRecentTopPhotos();

    if (communityPhotos) {
      dispatch(setCommunityPhotos(communityPhotos));
    }
  };

  const fetchSetDailyChallenges = async () => {
    const dailyChallenges = await getDailyChallenges(userId);
    // console.log({dailyChallenges});
    const formattedChallenges = await formatDailyChallenges(dailyChallenges);
    dailyChallenges && dispatch(setDailyChallenges(formattedChallenges));
  };

  useEffect(() => {
    fetchSetTopPhotos();

    fetchSetDailyChallenges();
  }, [userId]);

  return (
    <View style={{flex: 1, backgroundColor: global?.color?.white}}>
      <CallSupportLine />
      <TopTab>
        <TopTabButton
          text={'Daily Challenges'}
          handlePress={() => setView('daily')}
          active={view === 'daily'}
        />
        <TopTabButton
          text={'Top Photos'}
          handlePress={() => setView('photos')}
          active={view === 'photos'}
        />
      </TopTab>
      {view === 'daily' && <CommunityChallenges />}
      {view === 'photos' && (
        <CommunityPhotos fetchSetTopPhotos={() => fetchSetTopPhotos()} />
      )}
    </View>
  );
};

export default CommunityPage;
